/** Small, dependency-free helpers shared by the forms and their API routes. */

/** A single line of text: trimmed, no line breaks, capped at `max` characters. */
export const cleanLine = (value: unknown, max = 200): string => {
    if (typeof value !== 'string') return ''

    return value.replace(/[\r\n\t]+/g, ' ').replace(/\s{2,}/g, ' ').trim().slice(0, max)
}

/** Free text: trimmed and capped at `max` characters, line breaks kept. */
export const cleanText = (value: unknown, max = 4000): string => {
    if (typeof value !== 'string') return ''

    return value.replace(/\r\n/g, '\n').trim().slice(0, max)
}

export const isEmail = (value: string): boolean => {
    return value.length <= 254 && /^[^\s@<>(),;:"]+@[^\s@<>(),;:"]+\.[^\s@<>(),;:"]{2,}$/.test(value)
}

/** Accepts "studio.com" or a full address and returns it with a protocol, or '' when it is not a web address. */
export const cleanUrl = (value: unknown, max = 300): string => {
    const line = cleanLine(value, max)

    if (!line) return ''

    const withProtocol = /^https?:\/\//i.test(line) ? line : `https://${line}`

    try {
        const url = new URL(withProtocol)

        return url.hostname.includes('.') ? url.toString() : ''
    }
    catch {
        return ''
    }
}

export type FieldErrors<T extends string> = Partial<Record<T, string>>
